import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import { FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import { persistStore } from 'redux-persist';
import persistedReducer from './rootReducer';
import rootSaga from './sagas';
import { reconLoggerMiddleware } from './middlewares/reconLoggerMiddleware';

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => 
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
            FLUSH, 
            REHYDRATE, 
            PAUSE, 
            PERSIST, 
            PURGE, 
            REGISTER],
      },
    }).concat(reconLoggerMiddleware, sagaMiddleware) as any, // Cast to 'any' to bypass type checking
});

export const persistor = persistStore(store);

// Log the persisted state after rehydration
store.subscribe(() => {
  // console.log('Rehydrated State:', store.getState());
});

// Run the root saga
sagaMiddleware.run(rootSaga);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
